import { render, staticRenderFns } from "./CompanyCodes.vue?vue&type=template&id=20ab4b88"
import script from "./CompanyCodes.vue?vue&type=script&lang=js"
export * from "./CompanyCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports